import storage from "../lib/storage"

const { REACT_APP_ENV } = process.env

const S3_URLS = {
    staging: "https://stg-vlab-assets.vlab.live/",
    localhost: "https://stg-vlab-assets.vlab.live/",
    production: "https://vlab-assets.vlab.live/",
}

const S3_BUCKETS_DEFAULT = {
    staging: 'stg-assista_vlab_live',
    localhost: 'stg-assista_vlab_live',
    production: 'assista_vlab_live'
}

export const S3_URL = S3_URLS[REACT_APP_ENV]
export const DEFAULT_ORG_CODE = S3_BUCKETS_DEFAULT[REACT_APP_ENV]

let orgRoutesCachePromise = null

const getOrgRoutes = async () => {
    if (!orgRoutesCachePromise) {
        orgRoutesCachePromise = fetch(`${S3_URL}orgRoutes.watch.json`).then((r) => r.json())
    }
    return orgRoutesCachePromise
}

const findOrgCodeByPath = (orgRoutes, path) => {
    for (const [orgCode, orgPath] of Object.entries(orgRoutes || {})) {
        if (orgPath === path) return orgCode
    }
    return null
}

const getS3UrlByWindowLocation = async (file) => {
    const hostname = window.location.hostname
    const hostnameDashed = hostname.replace(/[.]/g, "_")

    if (hostname === "localhost" || hostname === "local.vlab.live") {
        return `https://stg-vlab-assets.vlab.live/stg-assista_vlab_live/${file}`
    }

    if (hostname === "local.medstreamer") {
        return `https://stg-vlab-assets.vlab.live/stg-assista_medstreamer_com/${file}`
    }

    const orgRoutes = await getOrgRoutes()
    const orgCode = findOrgCodeByPath(orgRoutes, hostnameDashed)

    if (orgCode) {
        if (file === "logo.png") {
            return `${S3_URL}${orgCode}/logo.png`
        }
        return `${S3_URL}${orgCode}/watch/${file}`
    }

    return `${S3_URL}${DEFAULT_ORG_CODE}/${file}`
}

const getS3UrlByOrganizationCode = async (file, id) => {
    const orgCode = id || DEFAULT_ORG_CODE
    if (file === "logo.png") {
        return `${S3_URL}${orgCode}/logo.png`
    }
    return `${S3_URL}${orgCode}/watch/${file}`
}

const getS3Url = async (file, organization) => {
    if (!window.location.hostname.includes("vbaby.app")) {
        const url = await getS3UrlByWindowLocation(file)
        return url
    }

    const id = organization ? organization : storage.getOrganization()
    const url = await getS3UrlByOrganizationCode(file, id)

    return url
}

export const getS3LogoUrl = async (organization) => await getS3Url("logo.png", organization)
export const getS3BackgroundUrl = async (organization) => await getS3Url("background.png", organization)
export const getS3SettingsUrl = async (organization) => {
    const url = await getS3Url("settings.json", organization)
    return await fetch(url)
}